import { getConfigInterceptors } from '@shared/utils'
import axios from 'axios'

import { OpenAPI } from './requests'

OpenAPI.BASE = import.meta.env.VITE_APP_CMS_API

export const $cmsAxios = axios.create({
  baseURL: import.meta.env.VITE_APP_CMS_API,

  headers: {
    'Content-Type': 'application/json'
  }
})

getConfigInterceptors($cmsAxios)
